import React from 'react';
import { TrendingUp, CheckCircle2 } from 'lucide-react';
import { Button } from '../ui/button';
import { formatCurrency } from './adminHelpers';

const SELL_PRICES = {
  'SHOficina': 268.90,
  'SHNF-e - Emissor NF-e': 409.90,
  'SHNFC-e - Cupom Fiscal': 435.90,
  'SHNFS-e - Nota de Serviços': 483.00,
};

const AdminCustos = ({ costConfig, setCostConfig }) => {
  const handleSave = () => {
    localStorage.setItem('admin_cost_config', JSON.stringify(costConfig));
  };

  return (
    <div className="p-6 overflow-y-auto">
      <h3 className="text-lg font-bold text-white mb-2 flex items-center gap-2">
        <TrendingUp className="w-5 h-5 text-cyan-400" />Custo de Aquisição por Licença
      </h3>
      <p className="text-sm text-slate-400 mb-6">Valores internos — NÃO aparecem para o cliente.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {Object.entries(costConfig).map(([name, cost]) => {
          const sellPrice = SELL_PRICES[name] || 0;
          return (
            <div key={name} className="bg-slate-800/50 border border-slate-700 rounded-xl p-4">
              <label className="block text-sm font-medium text-white mb-2">{name}</label>
              <div className="flex items-center gap-3">
                <div className="flex-1">
                  <label className="block text-xs text-slate-500 mb-1">Custo (R$)</label>
                  <input
                    type="number" step="0.01" value={cost}
                    onChange={e => setCostConfig(p => ({ ...p, [name]: parseFloat(e.target.value) || 0 }))}
                    className="w-full px-3 py-2 bg-slate-900 border border-slate-600 rounded-lg text-white text-sm focus:outline-none focus:border-cyan-500"
                  />
                </div>
                <div className="text-center">
                  <label className="block text-xs text-slate-500 mb-1">Venda</label>
                  <span className="text-cyan-400 font-bold text-sm">{formatCurrency(sellPrice)}</span>
                </div>
                <div className="text-center">
                  <label className="block text-xs text-slate-500 mb-1">Margem</label>
                  <span className="text-green-400 font-bold text-sm">{formatCurrency(sellPrice - cost)}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <Button onClick={handleSave} className="mt-6 bg-gradient-to-r from-cyan-600 to-blue-600 text-white font-bold">
        <CheckCircle2 className="w-4 h-4 mr-2" />Salvar
      </Button>
    </div>
  );
};

export default AdminCustos;
